import { useCallback } from "react";
import { useUser } from "./useUser";

/**
 * Generic hook to clear user-scoped cache entries from localStorage.
 *
 * @param scopeKey - The scope key (e.g., organizationKey or workspaceKey)
 * @param cacheKeys - An object containing cache key values to clear
 * @returns A callback function that clears all cache entries for the given scope and user
 */
export function useClearUserCache(
    scopeKey: string,
    cacheKeys: Record<string, string>,
): () => void {
    const user = useUser();

    return useCallback(() => {
        if (user) {
            Object.values(cacheKeys).forEach((cacheKey) => {
                const key = `${scopeKey}/${cacheKey}-${user.id}`;

                localStorage.removeItem(key);
            });
        }
    }, [scopeKey, user, cacheKeys]);
}
